// A small colored project badge: shows the chosen emoji on a tinted rounded
// square, or falls back to the project's first initial. The tint is derived
// from the project color so the icon reads as "owned" by that project.

function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function ProjectIcon({
  icon,
  color,
  name,
  size = 32,
}: {
  icon?: string | null;
  color?: string | null;
  name: string;
  size?: number;
}) {
  const accent = color || "#6366f1";
  const glyph = icon || name.trim()[0]?.toUpperCase() || "•";
  return (
    <span
      className="project-icon"
      style={{
        width: size,
        height: size,
        background: hexToRgba(accent, 0.16),
        color: accent,
        fontSize: icon ? size * 0.52 : size * 0.42,
        borderRadius: Math.round(size * 0.28),
      }}
      aria-hidden="true"
    >
      {glyph}
    </span>
  );
}
